import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProgramData, ProgramsInitialState } from '../../types/programs';

const initialState: ProgramsInitialState = {
  programData: [],
  errorMessage: '',
};

const eVisitsSlice = createSlice({
  name: 'programs',
  initialState,
  reducers: {
    getProgramDataRequest: (state, _: PayloadAction<{ providerId: string; userId: string }>) => {
      state.getProgramDataStatus = 'pending';
    },
    getProgramDataSuccess: (state, action: PayloadAction<ProgramData[]>) => {
      state.getProgramDataStatus = 'success';
      state.programData = action.payload;
    },
    getProgramDataError: (state, action: PayloadAction<string>) => {
      state.getProgramDataStatus = 'error';
      state.errorMessage = action.payload;
    },
  },
});

export const { actions, name, reducer } = eVisitsSlice;
export default reducer;
